import { SwedenDriverWorkYearsPeriods } from 'app/constants/configuration/swedenDriverWorkYearsPeriods'

export const getSwedenDriverWorkYearsPeriodsWorkName = (
  swedenDriverWorkYearsPeriods: SwedenDriverWorkYearsPeriods,
  translate: (string) => string,
): string => {
  const text: string =
    SwedenDriverWorkYearsPeriods[swedenDriverWorkYearsPeriods]
  return translate(`swedenDriverWorkYearsPeriods.${text}`)
}
